// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-031ee37c] {\n  color: var(--main-gray-5);\n  font-size: 16px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.w-link[data-v-031ee37c] { margin-bottom: 12px; text-decoration: underline;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
